<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">delete</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Excluir "{{ data.etapa.nome }}"?</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content class="modal-content">
  @if (data.automacoes.length) {
    <app-alert-card type="error" icon="bolt" [title]="tituloAutomacoes">
      <p class="mb-3">
        Esta etapa é o gatilho das automações abaixo. Ao excluir, a etapa é removida do campo <b>Quando</b> e a
        automação é <b>desligada</b>. Ela só volta a funcionar depois que você escolher um novo gatilho e ligá-la em
        Automações de ordem de serviço.
      </p>
      <div class="d-flex flex-column gap-2">
        @for (automacao of data.automacoes; track automacao.nome) {
          <div class="automacao-item d-flex align-items-center gap-3">
            <span class="automacao-icone">
              <mat-icon class="material-symbols-outlined">{{ automacao.icone }}</mat-icon>
            </span>
            <span class="flex-grow-1 fw-semibold">{{ automacao.nome }}</span>
            <span class="status-badge badge-vermelho">
              <mat-icon class="material-symbols-outlined">power_settings_new</mat-icon>
              {{ automacao.isAtivo ? 'Ativa → será desligada' : 'Inativa → perde o gatilho' }}
            </span>
          </div>
        }
      </div>
    </app-alert-card>
  }
  <app-alert-card type="warning" title="Esta operação não pode ser desfeita">{{ impacto }}</app-alert-card>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()">
    <mat-icon class="material-symbols-outlined">delete</mat-icon>
    {{ data.automacoes.length ? 'Excluir e desligar automações' : 'Excluir' }}
  </button>
</mat-dialog-actions>
